import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import * as _ from 'lodash';

/**
 * Displays a dialog (popup) with filters to select an option
 */
@Component({
  selector: 'app-filter-radiobutton-popup',
  templateUrl: './filter-radiobutton-popup.component.html',
  styleUrls: ['./filter-radiobutton-popup.component.scss']
})
export class FilterRadiobuttonPopupComponent {
  /** Dialog reference for popup */
  dialogRef: MatDialogRef<FilterRadiobuttonPopupComponent>;
  /** Injected data for popup */
  data: any;
  /** Init component inject MatDialogRef and data for dialog */
  constructor(
    dialogRef: MatDialogRef<FilterRadiobuttonPopupComponent>,
    @Inject(MAT_DIALOG_DATA) data: any) {
      this.dialogRef = dialogRef;
      this.data = data;
    }

  /** Close dialog (cancel action) */
  onNoClick(): void {
    this.dialogRef.close();
  }

  /** Close dialog with submit action */
  onSubmit() {
    this.dialogRef.close(this.data);
  }

  /** Check if option should be disabled */
  isOptionDisabled(slug: string, option: string): boolean {
    switch (slug) {
      case 'unidad':
        return this.data.config.disabled && this.data.config.disabled[slug] ? this.data.config.disabled[slug][option] : false;
      default:
        return this.data.config.disabled[slug];
    }
  }

  /** Validate if form is disabled */
  formIsDisabled(formPopup) {
    return formPopup.form.invalid ||
      (this.data.blocks.includes('columns') && this.data.selectedFilters.columns === 'Todos') ||
      (this.data.blocks.includes('categories') && this.data.selectedFilters.categories === 'Todos');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/filter-radiobutton-popup/filter-radiobutton-popup.component.ts